import {
  Checkbox as CheckboxComponent,
  TelInput as TelInputComponent,
  TextInput as TextInputComponent,
} from '@designsforhealth/dfh-react-components'
import { CheckboxProps } from '@designsforhealth/dfh-react-components/dist/components/CheckboxGroup/Checkbox'
import styled, { css } from 'styled-components'

import Link from '../../Link'

export const ContentContainer = styled.div`
  @counter-style paren-decimal {
    system: extends decimal;
    prefix: '(';
    suffix: ') ';
  }
  @counter-style paren-lower-alpha {
    system: extends lower-alpha;
    prefix: '(';
    suffix: ') ';
  }
  @counter-style paren-lower-roman {
    system: extends lower-roman;
    prefix: '(';
    suffix: ') ';
  }
  .paren-decimal {
    list-style: paren-decimal;
  }
  .paren-lower-alpha {
    list-style: paren-lower-alpha;
  }
  .paren-lower-roman {
    list-style: paren-lower-roman;
  }
  .outer-list {
    //TODO: remove indentation from outer list and allow content to wrap to left margin
    //padding-left: 10px;
  }
  .text-underline {
    text-decoration: underline;
  }
  .text-center {
    text-align: center;
  }
  .text-indent {
    padding-left: 30px;
  }
  .text-indent-2 {
    padding-left: 60px;
  }
  .text-italic {
    font-style: italic;
  }
`

export const AdditionalActionsContainer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.coolGray.cool450};
  margin-top: 30px;
  padding-top: 30px;
`

export const Checkbox = styled(CheckboxComponent)<
  CheckboxProps & { noGutterBottom?: boolean; readonly?: boolean }
>`
  max-width: 44em;
  ${({ noGutterBottom = false }) =>
    !noGutterBottom &&
    css`
      margin-bottom: 30px;
      &:not(:last-child) {
        margin-bottom: 30px;
      }
    `};
  ${({ readonly }) =>
    readonly
      ? css`
          pointer-events: none;
        `
      : css``};
};
`

export const WrappedLink = styled(Link)`
  color: inherit;
  word-wrap: break-word;
`

export const CheckboxLabel = styled.span<{ disabled?: boolean; readonly?: boolean }>`
  color: ${({ disabled, theme }) =>
    disabled ? theme.colors.coolGray.cool550 : theme.colors.brand.gray};
  font-size: initial;
  line-height: initial;
`

export const CheckboxAside = styled.div`
  color: ${({ theme }) => theme.colors.brand.gray};
  // limit max-width but accommodate entity table in RxDFHend for CA
  max-width: 44em;
  // align content with label
  margin-left: 22px;
  margin-bottom: 30px;
`

export const TextInput = styled(TextInputComponent)`
  max-width: 30em;
`

export const TelInput = styled(TelInputComponent)`
  max-width: 20em;
`
